<template>
    <button type="submit" v-promise-btn @click.prevent="getData($event)"  class="order__block-btn btn btn--red"><slot></slot></button>
</template>

<script>
    import Vue from 'vue'
    import VuePromiseBtn from 'vue-promise-btn'

    Vue.use(VuePromiseBtn, {
        autoHideSpinnerWrapper: true,
        loader: '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>'
    });

    export default {
        name: "spinner-button-submit",
        components: {
            VuePromiseBtn
        },
        methods: {
            getData (event) {
                // текст кнопки this.$el.textContent
                let form = event.target.form;

                return new Promise((resolve, reject) => {

                    form.submit();

                });
            }
        }
    }
</script>
